module.exports = __webpack_public_path__ + "img/alex-distributed-trainings.a5532e8c.png";